import { Component } from '@angular/core';
import { SessionSigninComponent } from '../../modules/besharp-sessions/lib/components/session-signin/session-signin.component';

@Component({
  selector: 'app-signin-page',
  standalone: true,
  imports: [SessionSigninComponent],
  templateUrl: './signin-page.component.html',
  styleUrls: ['./signin-page.component.scss']
})
export class SigninPageComponent { }
